module.exports = __webpack_public_path__ + "static/dot-pattern-2cd0e96ce0e200b9578bd45d123c2388.svg";